<template>
  <div id="house" :style="{'height': (height + 'px')}">
    <sidebar :house="house"
    :class="{'active': sidebarOpen, 'animate': !sidebarOpen && sidebarAnimated, 'hidden': !sidebarAnimated}"
    @close="closeSidebar" />
    <div class="house-content">
      <div class="mobile-back">
      <img src="@/assets/icons/bttn-back.svg" class="back-arrow" @click="goBack"/>
        <div class="text">
          {{house.full_address}}
        </div>
      </div>
      <div class="controls">
        <div class="control-plane control-plane-address">
          <div class="icon">
            <img src="@/assets/icons/ic-location-white.svg" alt />
          </div>
          <div class="text">
            {{house.full_address}}
          </div>
        </div>
        <div class="control-plane control-plane-buttons">
          <div class="panel-button" :class="{'active': activeMap === '3d'}" @click="activeMap = '3d'">3D model</div>
          <div class="panel-button" :class="{'active': activeMap === '2d'}" @click="activeMap = '2d'">2D map</div>
          <div class="panel-button" :class="{'active': activeMap === 'street'}" @click="activeMap = 'street'">Streetview</div>
        </div>
      </div>
      <div id="map3d" v-show="activeMap === '3d'" style="width: 100%; height: 100%">
        <renderer v-bind:building-id="$store.state.house.building_id" v-bind:solar-potential="this.$store.state.house.solar_potential"></renderer>
      </div>
      <div id="map2d" v-if="activeMap === '2d'">
        <l-map
          style="height: 100%; width: 100%"
          :zoom.sync="map_zoom"
          :max-zoom="20"
          :center="house.coordinates"
        >
          <l-tile-layer :url="tile_url"></l-tile-layer>
          <l-geo-json :geojson="geojson_parcels" :optionsStyle="style_parcels" > </l-geo-json>          
          <l-geo-json :geojson="geojson_buildings" :optionsStyle="style_buildings" > </l-geo-json> 
          <l-geo-json :geojson="geojson_swimming_pools" :optionsStyle="style_swimming_pools" > </l-geo-json>  
        </l-map>
      </div>
      <div id="street" v-if="activeMap === 'street'">
        <GmapStreetViewPanorama
          style="width: 100%; height: 100%"
          class="pano"
          :position="house.coordinates"
          :options="{
            fullscreenControl: false,
            addressControl: false
          }">
        </GmapStreetViewPanorama>
      </div>
      <div class="mobile-bottom-menu">
        <div class="bottom-menu-button" @click="openSidebar">
          Show building information
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// Vue.component('l-map', Vue2Leaflet.LMap)
// Vue.component('l-tile-layer', Vue2Leaflet.LTileLayer)
import Sidebar from "./../components/HouseSidebar";
import Renderer from './../../../Woningprijs/src/components/3DComponents/Renderer3D.vue';

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export default {
  name: "house",
  components: { 
    'sidebar': Sidebar,
    'renderer': Renderer,
  },
  data() {
    return {
      height: 400,
      sidebarOpen: false,
      sidebarAnimated: false,
      activeMap: '3d',
      map_zoom:18,
      tile_url:"https://api.mapbox.com/styles/v1/mapbox/satellite-streets-v11/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1Ijoia3ZhbmxvbWJlZWsiLCJhIjoiY2l4cnVtd3VuMDAzYjMwcGJnY3Fma2VrMyJ9.hQdHMbUXYGgrFnQlCunUnQ",
      house: {
        address: 'Kleine Schuurstraat 1 9040 Sint-Amandsberg (Gent)',
        coordinates: { lat:51.0728886, lng:3.7738913 }
      },
      geojson_parcels:"",
      geojson_buildings:"",
      geojson_swimming_pools:"",
      geojson_addresses:"",
    };
  },
  methods: {
    // The style of the buildings and parcels are functions. The parcel and building polygon for the house
    // have thicker boundaries
    style_buildings(feature) {
              return {
                "color": '#08519c',
                "fillColor": "#6baed6",
                "weight": feature.properties.target ? 2 : 0.75,
                "opacity": 1,
                "fillOpacity": feature.properties.target ? 1 : 0.4
              }
    },   
    style_parcels(feature) {
              return {
                "color": '#1abc9c',
                "fillColor": "#6baed6",
                "weight": 0.5,
                "opacity": 1,
                "fillOpacity": 0.1
              }
    },        
    style_swimming_pools(feature) {
      return {
        "color": '#003399',
        "fillColor": "#0044cc",
        "weight": 1,
        "opacity": 1,
        "fillOpacity": .8
      }
    },
    goBack() {
      this.$router.push({path: '/'})
    },
    closeSidebar() {
      this.sidebarAnimated = true;
      this.sidebarOpen = false;
      setTimeout(() => {
        this.sidebarAnimated = false;
      }, 500)
    },
    openSidebar() {
      this.sidebarOpen = true;
      this.sidebarAnimated = true;
    },
    getBuildingFeatures(){
      var params = {missing_3d_importance:'warning'};
      if (this.$store.state.captcha_token != null) {
        params.captcha_token = this.$store.state.captcha_token
      } 
      if (this.$store.state.apikey != null) {
        params.apikey = this.$store.state.apikey
      }
      this.$axios
        .get(process.env.VUE_APP_API_URL + "/features/" + this.$store.state.house.building_id,
            {
              params: params
            })
        .then((response) => {
          this.$store.state.house = Object.assign(this.$store.state.house, response.data);
          if (this.$store.state.house.f_touching_sides == 0) {
            this.$store.state.house.touching_side_type = 'Detached'
          } else if (this.$store.state.house.f_touching_sides == 1) {
            this.$store.state.house.touching_side_type = 'Semi-attached'
          } else if (this.$store.state.house.f_touching_sides >= 2) {
            this.$store.state.house.touching_side_type = 'Attached'
          } else {
            this.$store.state.house.touching_side_type = '-'
          }
          this.$store.state.house.coordinates = {
            lat: response.data.f_lat,
            lng: response.data.f_lng,
          }
          this.house = this.$store.state.house;
          this.get2Dmap()
        })
    },
    get2Dmap(){
      // 2D map
      this.$axios
        .get(process.env.VUE_APP_API_URL + "/map/scene2d",
        {
          params:{'building_id': this.$store.state.house.building_id,
                  'out_crs': 'epsg:4326'}
        })
        .then((response) => {
          this.geojson_addresses = response.data.addresses
          this.geojson_parcels = response.data.parcel_geojson
          this.geojson_buildings = response.data.building_geojson
          this.geojson_swimming_pools = response.data.swimming_pool_geojson
        })
    },
    setup_map: function(map_data){  

      // Map initialisation
      // this.map = L.map('map_container', {
      //   scrollWheelZoom:  false, 
      //   center: [this.$store.state.house.coordinates.lat,  this.$store.state.house.coordinates.lng], 
      //   zoom: 18,
      // });
      // L.tileLayer('https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
      //     attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, <a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="http://mapbox.com">Mapbox</a>',
      //     maxZoom: 20,
      //     id: 'mapbox.streets-satellite',
      //     accessToken: 'pk.eyJ1Ijoia3ZhbmxvbWJlZWsiLCJhIjoiY2l4cnVtd3VuMDAzYjMwcGJnY3Fma2VrMyJ9.hQdHMbUXYGgrFnQlCunUnQ'
      // }).addTo(this.map);
      // L.geoJSON(map_data.parcel_geojson, {
      //   style: {
      //     "color": "#1abc9c",
      //     "weight": 0.5,
      //     "opacity": 1,
      //     "fillOpacity": 0.05
      //   }
      // }).addTo(this.map);
      // L.geoJSON(map_data.building_geojson, {
      //   style: function(feature) {
      //     return {
      //       "color": '#08519c',
      //       "fillColor": "#6baed6",
      //       "weight": feature.properties.target ? 2 : 0.75,
      //       "opacity": 1,
      //       "fillOpacity": feature.properties.target ? 1 : 0.5
      //     };
      //   }
      // }).addTo(this.map); 
      // pass_this = this;
      // // Resize with a timeout the div
      // this.$nextTick(function () {
      //   pass_this.map.invalidateSize();
      // });
    }    
  },
  created() {
    // Get building features. If the features are correctly returned, the 2D map can be drawn.
    var url_full_address = getParameterByName('full_address')
    if (url_full_address != null) {
      this.$store.state.house.full_address = url_full_address
    }
    var url_building_id = getParameterByName('building_id')
    if (url_building_id != null) {
      this.$store.state.house.building_id = url_building_id
    }
    var url_level = getParameterByName('level')
    if (url_level != null) {
      this.$store.state.house.level = url_level
    }
    var url_solar_potential = getParameterByName('solar_potential')
    if (url_solar_potential != null) {
      this.$store.state.house.solar_potential = url_solar_potential
    }
    this.getBuildingFeatures()

    this.height = window.innerHeight;
    window.addEventListener("resize", () => {
      this.height = window.innerHeight;
    });
  },
  mounted() {
    this.activeMap = this.$store.state.house.level === '3' ? '3d': '2d';
  }
};
</script>

<style>
</style>